import NumberField from "../../../../NumberField";
import { Product } from "../../../slice/newFormReducers";
import { useColumnOnChangeFn, useColumnSelector } from "./hooks";

type Props = {
  uuid: string;
};

const key: keyof Product = "sellPrice";

export default ({ uuid }: Props) => {
  const value = useColumnSelector(uuid, key);
  const onChange = useColumnOnChangeFn(uuid, key, true);

  return (
    <NumberField
      value={value ? value.toString() : ""}
      onChange={onChange}
      suffix="TL"
      maxLength={10}
    />
  );
};
